module.exports = __webpack_public_path__ + "img/p_r.b23a8ff0.png";